module.exports = __webpack_public_path__ + "static/img/1_2_1_2.8d96f97d.jpg";